module.exports = __webpack_public_path__ + "img/template-06.8d8386cd.jpg";